import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export interface ISetSiteLevelEmbeddingConfigurationParams {
  allow: boolean;
  idpConfigurationId: string;
}

export class SetSiteLevelEmbeddingConfigurationRequest extends Request<ISetSiteLevelEmbeddingConfigurationParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteLevelEmbeddingConfigurationParams) {
    super('setSiteLevelEmbeddingConfiguration', params);
  }
}
